import { createGlobalStyle, css } from "styled-components";

import PoppinsLight from "../../../assets/fonts/Poppins/Poppins-Light.ttf";
import PoppinsBlack from "../../../assets/fonts/Poppins/Poppins-Black.ttf";
import PoppinsBold from "../../../assets/fonts/Poppins/Poppins-Bold.ttf";
import PoppinsRegular from "../../../assets/fonts/Poppins/Poppins-Regular.ttf";
import PoppinsMedium from "../../../assets/fonts/Poppins/Poppins-Medium.ttf";
import PoppinsSemiBold from "../../../assets/fonts/Poppins/Poppins-SemiBold.ttf";
import PoppinsExtraBold from "../../../assets/fonts/Poppins/Poppins-ExtraBold.ttf";
import NotoSansHebrewRegular from "../../../assets/fonts/NotoSansHebrew/NotoSansHebrew-Regular.ttf";
import NotoSansHebrewSemiBold from "../../../assets/fonts/NotoSansHebrew/NotoSansHebrew-SemiBold.ttf";
import NotoSansHebrewLight from "../../../assets/fonts/NotoSansHebrew/NotoSansHebrew-Light.ttf";

import "system-font-css";

const globalStyles = css`
  @font-face {
    font-family: Poppins;
    font-weight: 400; /*(regular)*/
    font-style: normal;
    src: url(${PoppinsRegular}) format("truetype");
  }

  @font-face {
    font-family: poppins;
    font-weight: 300; /*(regular)*/
    font-style: normal;
    src: url(${PoppinsLight}) format("truetype");
  }

  @font-face {
    font-family: Poppins;
    font-weight: 500; /*(medium)*/
    font-style: normal;
    src: url(${PoppinsMedium}) format("truetype");
  }

  @font-face {
    font-family: Poppins;
    font-weight: 600; /*(bold)*/
    font-style: normal;
    src: url(${PoppinsSemiBold}) format("truetype");
  }

  @font-face {
    font-family: Poppins;
    font-weight: 700; /*(bold)*/
    font-style: normal;
    src: url(${PoppinsBold}) format("truetype");
  }

  @font-face {
    font-family: "Poppins";
    font-weight: 800; /*(black)*/
    font-style: normal;
    src: url(${PoppinsExtraBold}) format("truetype");
  }

  @font-face {
    font-family: Poppins;
    font-weight: 900; /*(black)*/
    font-style: normal;
    src: url(${PoppinsBlack}) format("truetype");
  }

  @font-face {
    font-family: NotoSansHebrew;
    font-weight: 400; /*(regular)*/
    font-style: normal;
    src: url(${NotoSansHebrewRegular}) format("truetype");
  }

  @font-face {
    font-family: NotoSansHebrew;
    font-weight: 300; /*(regular)*/
    font-style: normal;
    src: url(${NotoSansHebrewLight}) format("truetype");
  }

  @font-face {
    font-family: NotoSansHebrew;
    font-weight: 600; /*(bold)*/
    font-style: normal;
    src: url(${NotoSansHebrewSemiBold}) format("truetype");
  }

  html {
    box-sizing: border-box;
    font-size: calc(14px + 0.25vw);
    font-family: Poppins;
    width: 100vw;
    height: 100%;
    min-height: 100vh;
    scrollbar-color: transparent;
    scrollbar-width: thin;
  }

  body {
    width: 100vw;
    height: 100%;
    font-family: Poppins;
    min-width: 100vw;
    min-height: 100vh;
    scrollbar-color: transparent;
  }

  body[dir="rtl"] {
    direction: rtl;
    font-family: NotoSansHebrew;
  }

  body[dir="ltr"] {
    direction: ltr;
    font-family: Poppins;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
    outline: none;
  }

  *:focus {
    outline: none;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    appearance: textfield;
  }

  a {
    text-decoration: none;
  }
`;

const GlobalStyles = createGlobalStyle`${globalStyles}`;
GlobalStyles.css = globalStyles;

export default GlobalStyles;
